export interface IOption {
  name: string;
  value: string;
}

export interface ILocalizedOption extends IOption {
  nameTc: string;
  nameSc: string;
}

export enum PAGE {
  FORM,
  PREVIEW,
  VALIDATION,
  INTERNAL_VALIDATION,
  RESULT,
}

export enum EDIT_PAGE {
  FORM,
  VALIDATION,
  BOOKING,
  RESULT,
}

export type LanguageCode = "en" | "zh-HK" | "zh-TW" | "zh-CN";

export enum POPUP_STATUS {
  WARNING,
  ERROR,
}

export interface KnownError {
  errorCode: number;
  msg: string;
  extras?: null;
}

export enum ERROR_CODE {
  BOOKING_SERVICE_DISABLED = 8053,
  INCORRECT_OTP = 9513,
  EXPIRED_OTP = 9514,
  SYSTEM_UPDATE = 9999,
}

export interface SecurePayload {
  ek: string;
  ep: string;
  hmac: string;
  ts: string;
  n: string;
}
